import { BeneficiariesProvider } from 'contexts/Beneficiaries';
import { HistoryBatchProvider } from 'contexts/HistoryBatch';
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import Beneficiaries from './Beneficiaries';
import BeneficiarySummary from './BeneficiarySummary';
import History from './History';

export const Main = () => {
  const [searchParams] = useSearchParams();

  const page = searchParams.get('p');

  const templatePage = useMemo(() => {
    switch (page) {
      case 'extrato-beneficiario':
        return <BeneficiarySummary />;
      case 'historico-importacoes':
        return (
          <HistoryBatchProvider>
            <History />
          </HistoryBatchProvider>
        );
      default:
        return <Beneficiaries />;
    }
  }, [page]);

  return <BeneficiariesProvider>{templatePage}</BeneficiariesProvider>;
};
